import { useEffect } from "react";
import CursorTrailCanvas from "../components/cursor-trail-canvas";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () => {
    useEffect(() => {
        const hasReloaded = sessionStorage.getItem("hasReloaded");

        if (!hasReloaded) {
            sessionStorage.setItem("hasReloaded", "true");
            window.location.reload();
        }
    }, []);
    return (
        <div className="flex flex-col items-center rounded-sm">
            <Navbar />
            <CursorTrailCanvas
                className="pointer-events-none fixed inset-0 z-10 h-full w-full"
                color="#F25B19"
            />
            <div className="w-full">
                <Outlet />
            </div>
            <Footer />
        </div>
    );
};

export default Layout;
